"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfopageExtensive = exports.isInfopage = exports.isTextEditorInfopageContent = exports.isStringInfopageContent = exports.isMediaInfopageContent = void 0;
// Typeguards for InfopageContent
exports.isMediaInfopageContent = (item) => item === null || item === void 0 ? void 0 : item.key;
exports.isStringInfopageContent = (item) => typeof item === 'string';
exports.isTextEditorInfopageContent = (item) => item === null || item === void 0 ? void 0 : item.html;
/** Typeguard for Infopage type */
exports.isInfopage = (item) => (item === null || item === void 0 ? void 0 : item.infopageId) && !(item === null || item === void 0 ? void 0 : item.template);
/** Typeguard for InfopageExtensive type */
exports.isInfopageExtensive = (item) => (item === null || item === void 0 ? void 0 : item.infopageId) && (item === null || item === void 0 ? void 0 : item.template);
//# sourceMappingURL=infopages.js.map